import {
  aksesoris,
  kuponServis,
  paketServis,
  servisBooking,
  sukuCadang,
  tradeIn,
} from '../../../assets/images';
import NavHomeIcon from '../../../components/atoms/Icons/NavHomeIcon';
import NavHomeIconFill from '../../../components/atoms/Icons/NavHomeIconFill';
import CarIcon from '../../../components/atoms/Icons/CarIcon';
import CarIconFill from '../../../components/atoms/Icons/CarIconFill';
import ServiceCarIcon from '../../../components/atoms/Icons/ServiceCarIcon';
import AskCsIcon2 from '../../../components/atoms/Icons/AskCsIcon2';
import eventNavbarMobile from 'ui/lib/gtm/eventNavbarMobile';
import eventTanyaTasia from 'ui/lib/gtm/eventTanyaTasia';
import { data } from 'jquery';

const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;
const ENABLE_USED_CAR_NEXTJS = process.env.NEXT_PUBLIC_ENABLE_USED_CAR_NEXTJS === 'true';
const menu = [
  {
    id: 1,
    dataTestId: 'tab_mobil_baru',
    name: 'Mobil Baru',
    path: `${PUBLIC_URL}/c/mobil-baru-toyota`,
    hideOnMobile: true,
    value: 'mobilbaru',
  },
  {
    id: 2,
    dataTestId: 'tab_purna_jual',
    name: 'Purna Jual',
    path: `${PUBLIC_URL}/services-toyota`,
    hideOnMobile: false,
    value: 'purnajual',
    listMenu: [
      {
        id: 'booking-servis',
        path: `${PUBLIC_URL}/services-toyota/booking-service`,
        image: servisBooking.src,
        title: 'Servis Booking',
      },
      {
        id: 'kupon-servis',
        path: `${PUBLIC_URL}/c/kupon-service`,
        image: kuponServis.src,
        title: 'Kupon Servis',
      },
      {
        id: 'aksesoris',
        path: `${PUBLIC_URL}/aksesoris`,
        image: aksesoris.src,
        title: 'Aksesoris',
      },
      {
        id: 'suku-cadang',
        path: `${PUBLIC_URL}/services-toyota/suku-cadang`,
        image: sukuCadang.src,
        title: 'Suku Cadang',
      },
      {
        id: 'trade-in',
        path: `${PUBLIC_URL}/services-toyota/tukar-tambah`,
        image: tradeIn.src,
        title: 'Tukar Tambah',
      },
      {
        id: 'paket-servis',
        path: `${PUBLIC_URL}/c/paketservistoyota`,
        image: paketServis.src,
        title: 'Paket Servis',
      },
    ],
  },
  {
    id: 3,
    dataTestId: 'tab_promo',
    name: 'Promo',
    path: `${PUBLIC_URL}/promosi`,
    hideOnMobile: false,
    value: 'promo',
  },
  {
    id: 4,
    dataTestId: 'tab_test_drive',
    name: 'Test Drive',
    path: `${PUBLIC_URL}/c/testdrive-toyota`,
    hideOnMobile: false,
    value: 'testdrive',
  },
  {
    id: 5,
    dataTestId: 'tab_mobil_bekas',
    name: 'Mobil Bekas',
    path: ENABLE_USED_CAR_NEXTJS
      ? `${PUBLIC_URL}/certified-used-car`
      : `${PUBLIC_URL}/c/certified-used-car-toyota`,
    hideOnMobile: false,
    value: 'certifiedusedcar',
  },
  {
    id: 6,
    dataTestId: 'tab_dealer_toyota',
    name: 'Dealer Toyota',
    path: `${PUBLIC_URL}/dealer-toyota`,
    hideOnMobile: false,
    value: 'dealertoyota',
  },
  {
    id: 7,
    dataTestId: 'tab_review_produk',
    name: 'Review Produk',
    path: `${PUBLIC_URL}/review-produk`,
    hideOnMobile: false,
    onClick: () => eventNavbarMobile('Review Produk'),
    value: 'reviewproduk',
  },
];
const mobileMenu = ({ isValueHome, isValueMobil, isValueService }: any) => {
  return [
    {
      id: 'home-icon',
      dataTestId: 'tab_home',
      path: `${PUBLIC_URL}`,
      redCircle: isValueHome ? true : false,
      icon: isValueHome ? <NavHomeIconFill /> : <NavHomeIcon height={24} width={24} />,
      title: 'Home',
      value: '',
    },
    {
      id: 'mobil-baru-icon',
      dataTestId: 'tab_mobil_baru',
      path: `${PUBLIC_URL}/c/mobil-baru-toyota`,
      redCircle: isValueMobil ? true : false,
      icon: isValueMobil ? <CarIconFill /> : <CarIcon height={24} width={24} />,
      title: 'Mobil Baru',
      value: 'mobilbaru',
    },
    {
      id: 'servis-icon',
      dataTestId: 'tab_servis',
      path: `${PUBLIC_URL}/services-toyota/booking-service`,
      redCircle: isValueService ? true : false,
      icon: <ServiceCarIcon height={24} width={24} fill={isValueService ? '#ffffff' : '#bebebe'} />,
      title: 'Servis',
      value: 'servicestoyota',
    },
    {
      id: 'chat-icon',
      dataTestId: 'tab_support',
      path: '#',
      redCircle: null,
      icon: <AskCsIcon2 height={24} width={25} />,
      title: 'Tanya Tasia',
      onClick: () => eventTanyaTasia(),
    },
  ];
};

export default { menu, mobileMenu };
